module.exports = __webpack_public_path__ + "7e4bb5d26ea197cb76b241b9aa1e1db5.png";